// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.NotifiTechCont{
    width: 100% !important;

}
 .NotifiTech{
  display: flex !important;
 }

  .NotifiTech .cont-table-roles {
    width: 100%;
    height: 100%;
  }
 
  .NotifiTech .head-table-users{
    justify-content: start;
  }
 
  .NotifiTech .contTable-right{
    width: 20%;
    height: 100%;
    /* background-color: red; */

  }
  .NotifiTech .contTable-right .headTitle{
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10%;
    background-color: rgb(138, 138, 138);
    /* background: #4392c0; */
    border-bottom: 1px solid #003757;
    border-radius: 5px 0px 0px 0px;
    color: aliceblue;
  }
  .NotifiTech-row-type{
    width: 100%;
    height: 33%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: x-small;
 
  }
  .NotifiTech-row-type:nth-child(odd){
    background-color: #f8f9fa;
  }
  .NotifiTech-row-type:nth-child(even){
    background-color: #eeeeee;
  }
  .row-table-users-NotifiTech:nth-child(odd){
    background-color: #f8f9fa;
  }
  .row-table-users-NotifiTech:nth-child(even){
    background-color: #eeeeee;
  }
  
  .row-table-users-NotifiTech:hover{
    background-color: #00375794;
    cursor: pointer;
    /* color: aliceblue !important; */
  }
  .row-table-users-NotifiTech{
    position: relative;
    display: flex;
    width: 100%;
    height: 40px;
    color:#003757;
  }`, "",{"version":3,"sources":["webpack://./src/components/admin-components/styles/NotifiTech.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;;AAE1B;CACC;EACC,wBAAwB;CACzB;;EAEC;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,2BAA2B;;EAE7B;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;;EAEpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,iCAAiC;EACnC;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;EACf","sourcesContent":["\r\n.NotifiTechCont{\r\n    width: 100% !important;\r\n\r\n}\r\n .NotifiTech{\r\n  display: flex !important;\r\n }\r\n\r\n  .NotifiTech .cont-table-roles {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n \r\n  .NotifiTech .head-table-users{\r\n    justify-content: start;\r\n  }\r\n \r\n  .NotifiTech .contTable-right{\r\n    width: 20%;\r\n    height: 100%;\r\n    /* background-color: red; */\r\n\r\n  }\r\n  .NotifiTech .contTable-right .headTitle{\r\n    width: 100%;\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 10%;\r\n    background-color: rgb(138, 138, 138);\r\n    /* background: #4392c0; */\r\n    border-bottom: 1px solid #003757;\r\n    border-radius: 5px 0px 0px 0px;\r\n    color: aliceblue;\r\n  }\r\n  .NotifiTech-row-type{\r\n    width: 100%;\r\n    height: 33%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    font-size: x-small;\r\n \r\n  }\r\n  .NotifiTech-row-type:nth-child(odd){\r\n    background-color: #f8f9fa;\r\n  }\r\n  .NotifiTech-row-type:nth-child(even){\r\n    background-color: #eeeeee;\r\n  }\r\n  .row-table-users-NotifiTech:nth-child(odd){\r\n    background-color: #f8f9fa;\r\n  }\r\n  .row-table-users-NotifiTech:nth-child(even){\r\n    background-color: #eeeeee;\r\n  }\r\n  \r\n  .row-table-users-NotifiTech:hover{\r\n    background-color: #00375794;\r\n    cursor: pointer;\r\n    /* color: aliceblue !important; */\r\n  }\r\n  .row-table-users-NotifiTech{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 40px;\r\n    color:#003757;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
